import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import type { ReduxState } from 'app/redux/types';

import { tFunction, useTranslation } from 'app/lang';
import type { RecordOfSportsState } from 'app/lib/betting/betting-entities';
import { sports } from 'app/modules/Search/selectors';
import Dropdown, { ChangeHandler, DropdownSize } from 'app/widgets/Dropdown/Single';

import DropdownComponents, { SearchOption } from './DropdownComponents';

import dictionary from './SportSelect.dictionary.json';

import styles from './SportsSelect.module.scss';

type StoreProps = {
  sports: RecordOfSportsState['byId'];
};

type Props = {
  activeSport: SearchOption;
  onChange: ChangeHandler<SearchOption>;
};

const getDefaultOption = (t: tFunction) => ({
  label: t(dictionary.label),
  value: 0,
});

const SportsSelect: React.FC<Props & StoreProps> = ({
  activeSport,
  sports,
  onChange,
}) => {
  const { t } = useTranslation();
  const sportOptions = useMemo(() => {
    const options: SearchOption[] = [];

    sports.forEach((sport) => {
      options.push({
        label: sport.name,
        value: sport.id,
      });
    });

    return options;
  }, [sports]);

  return (
    <div className={styles.selectContainer}>
      <Dropdown<SearchOption> value={activeSport}
                              components={DropdownComponents()}
                              defaultValue={activeSport}
                              openMenuOnFocus
                              isSearchable={false}
                              options={[getDefaultOption(t), ...sportOptions]}
                              className={styles.sportsSelect}
                              size={DropdownSize.MEDIUM}
                              onChange={onChange} />
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => {
  return {
    sports: sports(state),
  };
};

export default connect(mapStateToProps)(SportsSelect);
